import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    rootBar: {
      marginTop: 32,
      '& .MuiTabs-scrollable': {
        height: 35,
      },

      '& .MuiTabs-root': {
        minHeight: 35,
      },
      '& .MuiTabs-flexContainer': {
        height: 35,
      },

      '& .MuiTab-root': {
        minHeight: 35,
      },
    },

    barYellow: {
      backgroundColor: palette.superLightGray,
      boxShadow: '0 2px 4px 0 rgba(0,0,0,0.2)',
      height: 35,

      '& .MuiTabs-scrollable': {
        height: 35,
      },

      '& .PrivateTabScrollButton-root': {
        height: 35,
      },

      '& .PrivateTabScrollButton-root-690': {
        width: 0,
      },

      '& .MuiTabs-root': { minHeight: 35 },

      '& .MuiTabs-flexContainer': {
        justifyContent: 'space-around',
      },

      '& .MuiTabs-indicator': {
        backgroundColor: palette.navCompanyContextActions,
      },
    },
    barGreen: {
      backgroundColor: palette.superLightGray,
      boxShadow: '0 2px 4px 0 rgba(0,0,0,0.2)',
      height: 35,

      '& .MuiTabs-scrollable': {
        height: 35,
      },

      '& .PrivateTabScrollButton-root': {
        height: 35,
      },

      '& .PrivateTabScrollButton-root-690': {
        width: 0,
      },

      '& .MuiTabs-root': { minHeight: 35 },

      '& .MuiTabs-flexContainer': {
        justifyContent: 'space-around',
      },

      '& .MuiTabs-indicator': {
        backgroundColor: palette.navAdminActions,
      },
    },
    barGray: {
      backgroundColor: palette.superLightGray,
      boxShadow: '0 2px 4px 0 rgba(0,0,0,0.2)',
      height: 35,

      '& .MuiTabs-scrollable': {
        height: 35,
      },

      '& .PrivateTabScrollButton-root': {
        height: 35,
      },

      '& .PrivateTabScrollButton-root-690': {
        width: 0,
      },

      '& .MuiTabs-root': { minHeight: 35 },

      '& .MuiTabs-flexContainer': {
        justifyContent: 'space-around',
      },

      '& .MuiTabs-indicator': {
        backgroundColor: `${palette.navSuperAdminActions} !important`,
      },
    },
    barBlue: {
      backgroundColor: palette.superLightGray,
      boxShadow: '0 2px 4px 0 rgba(0,0,0,0.2)',
      height: 35,

      '& .MuiTabs-scrollable': {
        height: 35,
      },

      '& .PrivateTabScrollButton-root': {
        height: 35,
      },

      '& .PrivateTabScrollButton-root-690': {
        width: 0,
      },

      '& .MuiTabs-root': { minHeight: 35 },

      '& .MuiTabs-flexContainer': {
        justifyContent: 'space-around',
      },

      '& .MuiTabs-indicator': {
        backgroundColor: palette.navOperatorActions,
      },
    },

    tab: {
      transition: 'background 250ms linear',
      minHeight: 35,
      minWidth: 130,
      color: palette.deepBlack,
      fontWeight: 500,

      '&:hover': {
        textDecoration: 'none',
      },

      '&:disabled': {
        opacity: 0.7,
      },

      '& .MuiTab-wrapper': {
        fontSize: 14,
        color: palette.darkGray,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      },
    },

    tabGray: {
      '&.Mui-selected': {
        backgroundColor: palette.lightNavSuperAdminActions,
      },
    },
    tabYellow: {
      '&.Mui-selected': {
        backgroundColor: palette.lightNavCompanyContextActions,
      },
    },
    tabGreen: {
      '&.Mui-selected': {
        backgroundColor: palette.lightNavAdminActions,
      },
    },
    tabBlue: {
      '&.Mui-selected': {
        backgroundColor: palette.lightNavOperatorActions,
      },
    },
    maintenanceIcon: { marginRight: 10, marginBottom: '2px !important' },
    disableCursor: {
      '&.Mui-disabled': {
        cursor: 'not-allowed',
        pointerEvents: 'all',
      },
    },
  });
